export default "__VITE_ASSET__BDLHko4y__"